// SharedDataContext.js
import React from "react";

const SharedDataContext = React.createContext();

export default SharedDataContext;
